import { TextField } from "@mui/material";
import React, { useEffect, useRef } from "react";

const ValidatedTextFieldPassenger = ({
  value,
  setValue,
  error,
  setError,
  fullWidth = false,
  required = false,
  label,
  validator,
  age,
  type,
  style,
  multiline,
  rows,
  maxRows,
  fieldName,
  onUpdate,
}) => {
  const initialRef = useRef(true);

  useEffect(() => {
    if (required && !initialRef.current) {
      const timeout = setTimeout(() => {
        const errorMessage = validator(value);
        setError(errorMessage);
      }, [500]);

      return () => clearTimeout(timeout);
    }
    initialRef.current = false;
  }, [value, required, setError, validator]);

  const handleChange = (fieldName, val) => {
    setValue(val);
    onUpdate(fieldName, val);
  };

  let backgroundColor = "";
  let labelText = label

  if (age === 2) {
    backgroundColor = "#fff9c8";
    labelText += " (Dete)";
  } else if (age === 3) {
    backgroundColor = "#ffe6e8"; 
    labelText += " (Beba)";
  }


  
  return (
    <TextField
      label={labelText}
      value={value}
      onChange={(e) => handleChange(fieldName, e.target.value)}
      error={!!error}
      helperText={error || ""}
      required={required}
      fullWidth={fullWidth}
      type={type}
      style={style}
      rows={rows}
      multiline={multiline}
      maxRows={maxRows}
      sx={{
        "& .MuiOutlinedInput-input": {
          background: backgroundColor,
        },
      }}
    />
  );
};

export default ValidatedTextFieldPassenger;
